import React from 'react';
import './PrivacyPolicy.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <div className="privacy-container">
        <div className="privacy-content">
          <div className="privacy-header">
            <h1>Privacy Policy</h1>
            <p className="privacy-subtitle">Your privacy is important to us. Learn how we collect, use, and protect your information.</p>
          </div>

          <div className="privacy-sections">
            <section className="privacy-section">
              <h2>1. Information We Collect</h2>
              <ul>
                <li><strong>Personal Information:</strong> Name, email address, phone number, and government ID details</li>
                <li><strong>Booking Information:</strong> Check-in/check-out dates, bed preferences, and special requests</li>
                <li><strong>Payment Information:</strong> Payment details processed securely through Razorpay</li>
                <li><strong>Technical Information:</strong> IP address, browser type, and device information</li>
                <li><strong>Communication Data:</strong> Records of your communications with us</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>2. How We Use Your Information</h2>
              <ul>
                <li>Process and manage your bookings and reservations</li>
                <li>Send booking confirmations and important updates</li>
                <li>Provide customer support and respond to inquiries</li>
                <li>Ensure security and safety of all guests</li>
                <li>Improve our services and website functionality</li>
                <li>Comply with legal and regulatory requirements</li>
                <li>Send promotional offers (with your consent)</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>3. Information Sharing</h2>
              <ul>
                <li><strong>We do not sell</strong> your personal information to third parties</li>
                <li><strong>Payment Processing:</strong> Secure payment data is handled by Razorpay</li>
                <li><strong>Legal Requirements:</strong> We may share information when required by law</li>
                <li><strong>Service Providers:</strong> Trusted partners who help us operate our services</li>
                <li><strong>Emergency Situations:</strong> Information may be shared for safety purposes</li>
                <li>All third parties are bound by confidentiality agreements</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>4. Data Security</h2>
              <ul>
                <li>We use industry-standard encryption to protect your data</li>
                <li>Secure servers and firewalls protect against unauthorized access</li>
                <li>Payment information is processed through PCI-compliant systems</li>
                <li>Regular security audits and updates are performed</li>
                <li>Staff access to personal data is limited and monitored</li>
                <li>Data backups are encrypted and stored securely</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>5. Data Retention</h2>
              <ul>
                <li>Personal data is retained only as long as necessary</li>
                <li>Booking records are kept for 3 years for business purposes</li>
                <li>Payment data is retained as per legal requirements</li>
                <li>Marketing data is kept until you opt out</li>
                <li>You can request data deletion at any time</li>
                <li>Some data may be retained for legal compliance</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>6. Your Rights</h2>
              <ul>
                <li><strong>Access:</strong> Request a copy of your personal data</li>
                <li><strong>Correction:</strong> Update or correct inaccurate information</li>
                <li><strong>Deletion:</strong> Request deletion of your personal data</li>
                <li><strong>Portability:</strong> Receive your data in a portable format</li>
                <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
                <li><strong>Complaint:</strong> Lodge complaints with data protection authorities</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>7. Cookies and Tracking</h2>
              <ul>
                <li>We use cookies to improve website functionality</li>
                <li>Essential cookies are necessary for booking operations</li>
                <li>Analytics cookies help us understand website usage</li>
                <li>You can control cookie settings in your browser</li>
                <li>Third-party cookies may be used for payment processing</li>
                <li>We do not use cookies for targeted advertising</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>8. Third-Party Services</h2>
              <ul>
                <li><strong>Razorpay:</strong> Secure payment processing</li>
                <li><strong>EmailJS:</strong> Email notification services</li>
                <li><strong>Google Maps:</strong> Location services</li>
                <li><strong>Firebase:</strong> Data storage and authentication</li>
                <li>All third-party services have their own privacy policies</li>
                <li>We ensure third parties meet our privacy standards</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>9. Children's Privacy</h2>
              <ul>
                <li>Our services are not intended for children under 18</li>
                <li>We do not knowingly collect data from minors</li>
                <li>Parental consent is required for guests under 18</li>
                <li>If we discover child data, it will be deleted immediately</li>
                <li>Parents can contact us to remove their child's information</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>10. Updates to This Policy</h2>
              <ul>
                <li>This privacy policy may be updated periodically</li>
                <li>Significant changes will be communicated via email</li>
                <li>Continued use implies acceptance of updates</li>
                <li>Previous versions are available upon request</li>
                <li>Check this page regularly for the latest version</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>11. Contact Us</h2>
              <ul>
                <li><strong>Address:</strong> 3rd Floor, ICICI Bank, 1-8, 303/30, Shree Arcade Building, PG Road, Sindhi Colony, Begumpet, Hyderabad, Telangana 500003</li>
                <li><strong>Phone:</strong> +91 90327 97797</li>
                <li><strong>Email:</strong> privacy@skylinebackpackers.in</li>
                <li><strong>Data Protection Officer:</strong> booking@skylinebackpackers.in</li>
                <li>We will respond to privacy inquiries within 30 days</li>
              </ul>
            </section>
          </div>

          <div className="privacy-footer">
            <p>By using our services, you acknowledge that you have read and understood this Privacy Policy and agree to the collection and use of your information as described.</p>
            <p className="privacy-last-updated">Last updated: August 2025</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
